export const enum FILETYPE {
  IMAGE = "image",
  VIDEO = "video",
  UNKNOWN = "unKnown",
}
